<template>
  <div v-if="this.document" class="container">
    <navBar/>

    <div class="container" ref="validation">
      <div class="row">
        <vs-col>
          <h1 class="text-primary text-center mb-5 mt-3">Verificación del documento</h1>
          <p class="mb-5"> Los documentos generados por la plataforma Verificamex cuentan con un sello digital de tiempo (TimeStamp) en el momento de la firma, así como con una constancia de conservación (del mensaje de datos) de acuerdo con la NOM-151. Este documento produce los mismos efectos jurídicos que la firma autógrafa. <a target="_blank" href="https://verificamex.com/es/legal">Más información.</a></p>
        </vs-col>
        <vs-col>
          <h4 class="text-primary text-left mb-2 d-inline-block pr-3 mt-3">Estado de la Firma del Documento</h4>
          <div data-html2canvas-ignore class="mb-5 float-right download-buttons">
            <vs-button class="mr-4" @click="download">Descargar</vs-button>
            <vs-button @click="print">Imprimir</vs-button>
          </div>
          <vs-alert class="d-inline-block " color="success" active="true" icon="check_circle_outline">
            Documento válido
          </vs-alert>
        </vs-col>
      </div>

      <div class="row" style="page-break-after: always">
        <vs-col>
          <vs-card class=" mt-5">
            <div class="p-3">
              <div slot="header">
                <h4 class="mb-3">
                  <feather-icon icon="FileTextIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-primary"></feather-icon>
                  Información del documento firmado</h4>
              </div>
              <div>
                <table class="mb-0">
                  <tbody>
                  <tr>
                    <td style="width: 35.5%"><strong>Nombre del documento:</strong></td>
                    <td class="wbrake">{{ this.document.attributes.file_name }}</td>
                  </tr>
                  <tr>
                    <td>Identificador único del documento (Hash):</td>
                    <td class="wbrake">{{ this.document.attributes.original_hash.toLowerCase() }}</td>
                  </tr>
                  <tr>
                    <td>Estrategia de firmado:</td>
                    <td>{{ sign_strategies[this.document.attributes.signature_mode] }}</td>
                  </tr>
                  <tr>
                    <td>Dueño del documento:</td>
                    <td class="wbrake">{{ this.document.attributes.owner }}</td>
                  </tr>
                  <tr>
                    <td>Fecha de Firmado (UTC):</td>
                    <td>{{ this.document.attributes.signed_at }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </vs-card>
        </vs-col>
      </div>

      <div class="row">
        <vs-col>
          <h4 class="text-primary mt-5 mb-3">Firmas e identificación de las partes</h4>
          <!--<p class="mb-5">De conformidad con la legislación aplicable en materia de firma electrónica en México, los documentos que cuentan con Firma Electrónica Avanzada producen los mismos efectos jurídicos que los presentados con firma autógrafa. Los documentos generados por la plataforma Verificamex cuentan con un sello digital de tiempo estampado en el momento de la firma, así como con una constancia de conservación de acuerdo con la NOM-151.
            <a href="https://verificamex.com">Más información.</a></p>-->
        </vs-col>
      </div>

      <div class="row" v-for="signature in this.document.relationships.signatories.data" :key="signature.id" style="page-break-after: always">
        <vs-col>
          <vs-card class="mt-4">
            <div class="p-3">
              <div slot="header">
                <h4 class="mb-3">
                  <feather-icon icon="Edit3Icon" class="top-4 text-primary" svgClasses="w-5 h-5 text-primary"></feather-icon>
                  Información del firmante</h4>
              </div>
              <table class="mb-0">
                <tbody>
                <tr>
                  <td style="width: 27.5%" ><strong>Nombre completo del firmante:</strong></td>
                  <td class="wbrake">{{ signature.attributes.name }}</td>
                </tr>
                <tr>
                  <td>RFC:</td>
                  <td>{{ signature.attributes.rfc }}</td>
                </tr>
                <tr>
                  <td>CURP:</td>
                  <td>{{ signature.attributes.curp }}</td>
                </tr>
                <tr>
                  <td>Numero de certificado:</td>
                  <td>{{ signature.attributes.certificate_serial_number }}</td>
                </tr>
                <tr>
                  <td>Autoridad certificadora:</td>
                  <td>{{ signature.attributes.certificate_issuer_name }}</td>
                </tr>
                <tr>
                  <td>Firma electrónica:</td>
                  <td style="word-break: break-all!important;font-size: 11px;">{{ signature.attributes.signature }}</td>
                </tr>
                <tr>
                  <td>Fecha y hora de firma (UTC):</td>
                  <td>{{ signature.attributes.signed_at }}</td>
                </tr>
                </tbody>
              </table>
              <br>
              <div>
                <h5 class="mb-2">Información de sello digital de tiempo (TimeStamp)</h5>
              </div>
              <table class="mb-0">
                <tbody>
                <tr>
                  <td style="width: 27.5%"><strong>Nombre del emisor:</strong></td>
                  <td>{{ signature.relationships.timestamp.data[0].attributes.name }}</td>
                </tr>
                <tr>
                  <td>Numero de serie del emisor:</td>
                  <td>{{ signature.relationships.timestamp.data[0].attributes.serialNumber }}</td>
                </tr>
                <tr>
                  <td>Fecha y hora de emisión (UTC):</td>
                  <td>{{ signature.relationships.timestamp.data[0].attributes.createdAt }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </vs-card>

        </vs-col>
      </div>

      <div class="row">
        <vs-col>
          <h4 class="text-primary mt-5 mb-3">Constancia de Conservación NOM-151</h4>
          <!--<p class="mb-5">El presente documento cuenta con una Constancia de Conservación de Mensajes de Datos (Constancia de Conservación NOM-151) emitida por un Prestador de Servicios de Certificación (PSC) debidamente acreditado por la Secretaría de Economía, en cumplimiento de lo establecido en la Norma Oficial Mexicana “NOM-151-SCFI-2016, Requisitos que deben observarse para la conservación de mensajes de datos y digitalización de documentos”.</p>-->
        </vs-col>
      </div>

      <div class="row">
        <vs-col>
          <vs-card class="mt-4 mb-5">
            <div class="p-3">
              <div slot="header">
                <h4 class="mb-3">
                  <feather-icon icon="CheckSquareIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-primary"></feather-icon>
                  Información de NOM-151</h4>
              </div>
              <div>
                <table class="mb-0">
                  <tbody>
                  <tr>
                    <td style="width: 35%"><strong>Identificador único del documento (Hash):</strong></td>
                    <td class="wbrake">{{ this.document.attributes.original_hash.toLowerCase() }}</td>
                  </tr>
                  <tr>
                    <td>PSC Emisor:</td>
                    <td>{{ this.document.relationships.constancy.data[0].attributes.name }}</td>
                  </tr>
                  <tr>
                    <td>Número de Certificado usado por el PSC:</td>
                    <td>{{ this.document.relationships.constancy.data[0].attributes.serialNumber }}</td>
                  </tr>
                  <tr>
                    <td class="vertical-top">Fecha y Hora de Emisión de la Constancia (UTC):</td>
                    <td class="vertical-top">{{ this.document.relationships.constancy.data[0].attributes.createdAt }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </vs-card>
        </vs-col>
      </div>

    </div>
  </div>
</template>

<script>
import router from "@/router";
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {SIGN_STRATEGIES} from "../../../../config/app";
import html2pdf from 'html2pdf.js';

export default {
  name: "ShowDocument",
  components: {
    navBar
  },
  data() {
    return {
      uuid: "",
      document: null,
      sign_strategies: SIGN_STRATEGIES
    }
  },
  methods: {
    print() {
      window.print()
    },
    download() {
      html2pdf(this.$refs.validation, {
        margin: 1,
        filename: this.uuid + '.pdf',
        html2canvas: {dpi: 192, letterRendering: true},
        jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait'},
        pagebreak: {
          mode: ['css', 'legacy']
        }
      })
    }
  },
  created() {
    let uuid = this.$route.params.uuid
    if (uuid) {
      this.uuid = uuid;
    } else {
      router.push("/");
    }

    this.$store.dispatch("documentVerify/getDocument", {uuid: this.uuid})
    .then(document => {
      this.document = document;
      if (this.document.attributes.sign_status !== 3) {
        router.push("/");
      }
    })
  },
  destroyed() {
    this.$store.dispatch("documentVerify/flushDocument");
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  h1, .h1 {
    font-size: 24px!important;
  }
  table {
    width: 100%;
  }
  /*tr:nth-child(even) {background-color: #f8f8f8;}*/
  /*td:nth-child(2)  {
    word-break: break-all !important;
  }*/
  td:first-child  {
    background:#f8f8f8;
    font-weight: bold;
  }
  td{
    display: block;

    width: 100%!important;
  }
}
.wbrake{
  word-break: break-all !important;
}
td {

  padding: .5rem;
}
@media print {
  .navbar-horizontal-layout {
    display: none;
  }
  .download-buttons {
    display: none;
  }
}
</style>
